// Print.jsx
import React from "react";

export const Print = ({ className = "" }) => {
  const handlePrint = () => {
    window.print(); // Print the entire page
  };

  return (
    <button
      onClick={handlePrint}
      className={`px-4 py-2 bg-purple-500 text-white rounded hover:bg-purple-600 ${className}`}
    >
      Print
    </button>
  );
};